var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 23,
    height: 23
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.55,6.778,9.22,8.1l2.47,2.456H2v1.889h9.69L9.22,14.9l1.33,1.322L15.3,11.5ZM19.1,18.111H11.5V20h7.6A1.9,1.9,0,0,0,21,18.111V4.889A1.9,1.9,0,0,0,19.1,3H11.5V4.889h7.6Z",
    transform: "translate(-2 -3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogin);
export default __webpack_public_path__ + "static/media/icon_login.47b99715127256c0fde0082373d29143.svg";
export { ForwardRef as ReactComponent };